import {isTrackReference, TrackReference, useTracks} from '@livekit/components-react';
import {Track} from 'livekit-client';
import {api} from '@kcast-fe/core';

// Identity of a camera livestream (Ricoh Theta X) published into the room by its bridge:
// theta-<user_id>-<camera_id>, one participant per camera
const CAMERA_IDENTITY_PREFIX = 'theta-';

export interface ILiveStreamVideo {
  video: TrackReference;
  // Position of the camera in the stream settings (Camera 1 = 0): the window's place
  index: number;
}

// Videos of the camera livestreams in the room, in camera order
export const useLiveStreamTracks = (): ILiveStreamVideo[] => {
  const tracks = useTracks([Track.Source.Camera, Track.Source.Unknown], {onlySubscribed: true});
  const {data: settings} = api.cameras.useCameraStreamSettingsQuery();

  const cameraIds = settings?.cameras.map((c) => c.id) ?? [];
  const cameraIndex = (identity: string) => {
    const index = cameraIds.findIndex((id) => identity.endsWith(`-${id}`));
    // A camera not in the settings (yet) goes after the known ones
    return index === -1 ? cameraIds.length : index;
  };

  return tracks
    .filter(
      (t): t is TrackReference =>
        isTrackReference(t) &&
        t.participant.identity.startsWith(CAMERA_IDENTITY_PREFIX) &&
        t.publication.kind === Track.Kind.Video
    )
    .map((video) => ({video, index: cameraIndex(video.participant.identity)}))
    .sort((a, b) => a.index - b.index);
};
